import React, { useCallback, useEffect, useState } from 'react'
import { Button, Container, Placeholder, Table } from 'react-bootstrap'
import OrderService from '../../services/order-service';
import { useAuth } from '../../context/auth-context';
import { Orders as UserOrders } from '../../types';
import { capitalizeWords, formatDate, thousandSeparator } from '../../helper/utils';
import { Folder2Open } from 'react-bootstrap-icons';
import { mapStatusToColor } from '../../data/map-file';
import { Link } from 'react-router-dom';

const Orders = () => {

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [orders, setOrders] = useState<UserOrders[]>([]);
    const { user } = useAuth();


    const fetchUserOrders = useCallback(async (id: string) => {
        try {
            setIsLoading(true);
            const data = await OrderService.getOrdersByUserId(id);
            setOrders(data);
        } catch (error) {}
        finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {

        if (!user?.id) {
            return ;
        }

        void fetchUserOrders(String(user.id));

    }, [user?.id]);

    return (
        <Container>
            <h4 style={{ fontSize: '1.4rem' }} className='mb-4'>Your Orders</h4>
            {isLoading ? <Placeholder animation='glow' /> : (
                <Table responsive="sm" style={{ width: '100%', backgroundColor: 'transparent' }}>
                    <thead >
                        <tr>
                            <th 
                                className='py-2 pl-6 text-left border-bottom' 
                                style={{backgroundColor: '#f0f3f2', fontSize: '.9rem', color: '#717171', fontWeight: 600}}
                            >#</th>
                            <th 
                                className='py-2 pl-6 text-left'
                                style={{backgroundColor: '#f0f3f2', fontSize: '.9rem', color: '#717171', fontWeight: 600}}
                            >Order Number</th>
                            <th 
                                className='py-2 pl-6 text-left'
                                style={{backgroundColor: '#f0f3f2', fontSize: '.9rem', color: '#717171', fontWeight: 600}}
                            >Quantity</th>
                            <th 
                                className='py-2 pl-6 text-left'
                                style={{backgroundColor: '#f0f3f2', fontSize: '.9rem', color: '#717171', fontWeight: 600}}
                            >Amount</th>
                            <th 
                                className='py-2 pl-6 text-left'
                                style={{backgroundColor: '#f0f3f2', fontSize: '.9rem', color: '#717171', fontWeight: 600}}
                            >Status</th>
                            <th 
                                className='py-2 pl-6 text-left'
                                style={{backgroundColor: '#f0f3f2', fontSize: '.9rem', color: '#717171', fontWeight: 600}}
                            >Delivery date</th>
                            <th 
                                className='py-2 pl-6 text-left'
                                style={{backgroundColor: '#f0f3f2', fontSize: '.9rem', color: '#717171', fontWeight: 600}}
                            >Shipment method</th>
                            <th 
                                className='py-2 pl-6 text-left'
                                style={{backgroundColor: '#f0f3f2', fontSize: '.9rem', color: '#717171', fontWeight: 600}}
                            >Ordered date</th>
                            <th 
                                className='py-2 pl-6 text-left'
                                style={{backgroundColor: '#f0f3f2', fontSize: '.9rem', color: '#717171', fontWeight: 600}}
                            ></th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((order: UserOrders, i:number) => {
                            return (
                                <tr key={order.id}>
                                    <td style={{fontSize: '.9rem', color: '#717171', verticalAlign: 'bottom'}}>{i+1}</td>
                                    <td style={{fontSize: '.9rem', color: '#717171', verticalAlign: 'bottom'}}><Link to="">{order.orderNumber}</Link></td>
                                    <td style={{fontSize: '.9rem', color: '#717171', verticalAlign: 'bottom'}}>{order.orderItems.reduce((acc, item) => acc + item.quantity ,0)}</td>
                                    <td style={{fontSize: '.9rem', color: '#717171', verticalAlign: 'bottom'}}>{order.orderItems[0].currency + thousandSeparator(String(order.totalPrice))}</td>
                                    <td style={{fontSize: '.8rem', verticalAlign: 'bottom'}}><span className={`bg-${mapStatusToColor[order.status]} p-1 rounded text-white`}>{capitalizeWords(order.status.toLowerCase())}</span></td>
                                    <td style={{fontSize: '.9rem', color: '#717171', verticalAlign: 'bottom'}}>{formatDate(order.deliveryDate)}</td>
                                    <td style={{fontSize: '.9rem', color: '#717171', verticalAlign: 'bottom'}}>{capitalizeWords(order.shippingMethod)}</td>
                                    <td style={{fontSize: '.9rem', color: '#717171', verticalAlign: 'bottom'}}>{formatDate(order.createdAt)}</td>
                                    <td style={{fontSize: '.9rem', color: '#717171', verticalAlign: 'bottom'}}>
                                        <Button type='button' className='rounded' variant='danger' size='sm' style={{
                                            padding: '.2rem',
                                            lineHeight: 0,
                                        }}>
                                            <Folder2Open color='#fff' width={15} height={15} />
                                        </Button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            )}


        </Container>
    )
}

export default Orders
